import { useState } from 'react';
import Button from '../../../../components/Button/Button';
import FormHeading from '../../../../components/Typography/FormHeading';
import UploadProgressBar from '../../../../components/UploadProgressBar';
import useDocumentUpload from '../../../../hooks/useDocumentUpload';
import {
  DEAL_STATUS_DOCUMENTS_PROCESSING,
  DEAL_STATUS_WAITING_FOR_FREEDOM,
  DEAL_STATUS_WAITING_FOR_REGISTRATION_DOCUMENTS,
  DEAL_STEPS,
  DOCUMENT_TYPES_CERTIFICATE_OF_CIRCUMSTANCES,
  DOCUMENT_TYPES_CONTRACT,
  DOCUMENT_TYPES_GUARANTEE_LETTER,
  DOCUMENT_TYPES_INVOICE,
  DOCUMENT_TYPES_POLES,
  DOCUMENT_TYPES_TECH_PASSPORT,
  PAYMENT_STATUS_PAID,
} from '../../../../constants';
import LoaderInline from '../../../../components/Loader/LoaderInline';
import FreedomClientDocuments from './ClientDocuments';
import FreedomPaymentStatus from './PaymentStatus';
import FreedomCarRegistration from './CarRegistration';
import editDeal from '../../../../api/deals/editDeal';
import generateAllowedDocumentsJson from '../../../../utils/generateAllowedDocumentsJson';
import setStep from '../../../../api/deals/setStep';
import sendMarriedDoc from '../../../../api/creditPlatform/sendMarriedDoc';
import alert from '../../../../helpers/alert';
import initialFeeCreditCardPayment from '../../../../api/deals/initialFeeCreditCardPayment';
import ffinReRegisterConfirm from '../../../../api/bank/ffinReRegisterConfirm';
import ffinAddOwner from '../../../../api/bank/ffinAddOwner';
import ffinRestartOwner from '../../../../api/bank/ffinRestartOwner';
import ffinUpdateOwnerPhone from '../../../../api/bank/ffinUpdateOwnerPhone';
import extractErrorMessage from '../../../../utils/extractErrorMessage';
import StepControlButtons from '../CommonBankSteps/StepControlButtons';
import ContractSign from '../CommonBankSteps/ContractSign';
import FreedomOwnerInfo from './OwnerInfo';

const FreedomFlow = ({
  step,
  deal,
  documents,
  backHandler,
  update,
  chosenBankAppealId,
  chosenBankAppeal,
  cars,
  bankId,
}) => {
  const [loading, setLoading] = useState(false);
  const { upload, uploading, progress, currentFileName } = useDocumentUpload();

  const onPaymentSubmit = (values) => {
    if (values?.status?.value != PAYMENT_STATUS_PAID) return;

    setLoading(true);
    editDeal({
      id: deal?.id,
      statusPaymentId: values?.status?.value,
      statusId: DEAL_STATUS_WAITING_FOR_REGISTRATION_DOCUMENTS,
      ...generateAllowedDocumentsJson([
        DOCUMENT_TYPES_CERTIFICATE_OF_CIRCUMSTANCES,
        DOCUMENT_TYPES_GUARANTEE_LETTER,
        DOCUMENT_TYPES_INVOICE,
      ]),
    })
      .then(async () => {
        await setStep({ dealId: deal?.id, step: DEAL_STEPS.FREEDOM.AUTO_REGISTRATION });

        alert.success('Ð¡ÑÐ°ÑÑÑ Ð¾Ð¿Ð»Ð°ÑÑ ÑÑÐ¿ÐµÑÐ½Ð¾ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½');
        update && update();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const sendPaymentSms = () => {
    setLoading(true);
    initialFeeCreditCardPayment({
      bankId: bankId,
      chunkId: deal?.chunkId,
    })
      .then(() => {
        alert.success('Ð¡Ð¼Ñ ÑÐ¾ ÑÑÑÐ»ÐºÐ¾Ð¹ Ð½Ð° Ð¾Ð¿Ð»Ð°ÑÑ Ð¾ÑÐ¿ÑÐ°Ð²Ð»ÐµÐ½Ð¾ Ð½Ð° Ð½Ð¾Ð¼ÐµÑ ÑÐµÐ»ÐµÑÐ¾Ð½Ð° ÐºÐ»Ð¸ÐµÐ½ÑÐ°');
      })
      .catch((err) => {
        alert.error(err?.response?.data?.message || 'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð¾ÑÐ¿ÑÐ°Ð²Ð¸ÑÑ ÑÐ¼Ñ ÑÐ¾ ÑÑÑÐ»ÐºÐ¾Ð¹ Ð½Ð° Ð¾Ð¿Ð»Ð°ÑÑ')
      })
      .finally(() => setLoading(false));
  };


  // ÐÐ¾Ð¼Ð¸ÑÑÐ¸Ð¾Ð½Ð½Ð¾Ðµ Ð°Ð²ÑÐ¾ (THRIFT / THRIFT_SUBSIDIZED / THRIFT_CASCADE): Ð±Ð°Ð½Ðº
  // Ð²Ð°Ð»Ð¸Ð´Ð¸ÑÑÐµÑ Ð½Ð°Ð»Ð¸ÑÐ¸Ðµ Ð²Ð»Ð°Ð´ÐµÐ»ÑÑÐ° Ð² /re-register/confirm, Ð¿Ð¾ÑÑÐ¾Ð¼Ñ Ð´Ð¾ Ð¾ÑÐ¿ÑÐ°Ð²ÐºÐ¸
  // Ð²Ð»Ð°Ð´ÐµÐ»ÑÑÐ° ÑÐ°Ð³ Ð¿ÐµÑÐµÑÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ð¸ Ð·Ð°ÐºÑÑÐ²Ð°ÐµÐ¼. ownerSentAt Ð¿ÑÐ¾ÑÑÐ°Ð²Ð»ÑÐµÑ Ð±ÑÐºÐµÐ½Ð´
  // Ð¿Ð¾ÑÐ»Ðµ ÑÑÐ¿ÐµÑÐ½Ð¾Ð³Ð¾ POST /owner.
  const isConsignment = (chosenBankAppeal?.stockType || '').toUpperCase().startsWith('THRIFT');
  const ownerSent = Boolean(chosenBankAppeal?.ownerSentAt);
  const needsOwner = isConsignment && !ownerSent;

  // ÐÐ¾Ð¼Ð¸ÑÑÐ¸Ð¾Ð½Ð½Ð¾Ðµ Ð°Ð²ÑÐ¾ Ð¸Ð´ÑÑ Ð¿Ð¾ ÑÐºÐ¾ÑÐ¾ÑÐµÐ½Ð½Ð¾Ð¼Ñ Ð¼Ð°ÑÑÑÑÑÑ: ÐÐÐ â Ð¾Ð¿Ð»Ð°ÑÐ° ÐÐ â
  // Ð¿ÐµÑÐµÑÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ñ (Ð²Ð»Ð°Ð´ÐµÐ»ÐµÑ + ÑÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ñ Ð¢Ð¡) â Ð²ÑÐ´Ð°ÑÐ°. Ð­ÐºÑÐ°Ð½Ñ Â«Ð¾Ð¶Ð¸Ð´Ð°Ð½Ð¸Ðµ
  // Ð´ÐµÐ¹ÑÑÐ²Ð¸Ð¹ ÐºÐ»Ð¸ÐµÐ½ÑÐ° Ð½Ð° ÑÐ°Ð¹ÑÐµ Ð±Ð°Ð½ÐºÐ°Â» Ð¸ Â«Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÑ ÐºÐ»Ð¸ÐµÐ½ÑÐ°Â» Ð¾ÑÐ½Ð¾ÑÑÑÑÑ ÑÐ¾Ð»ÑÐºÐ¾ Ðº
  // Ð½Ð¾Ð²ÑÐ¼ Ð°Ð²ÑÐ¾, Ð´Ð»Ñ ÐºÐ¾Ð¼Ð¸ÑÑÐ¸Ð¾Ð½ÐºÐ¸ Ð¸Ñ Ð¿ÑÐ¾Ð¿ÑÑÐºÐ°ÐµÐ¼.
  const stepAfterSign = isConsignment
    ? DEAL_STEPS.FREEDOM.WAITING_FOR_PAYMENT
    : DEAL_STEPS.FREEDOM.WAITING_FOR_CLIENT_ACTIONS_ON_FREEDOM_SITE;
  const stepBeforePayment = isConsignment
    ? DEAL_STEPS.FREEDOM.SIGN_CONTRACT
    : DEAL_STEPS.FREEDOM.WAITING_FOR_CLIENT_DOCUMENTS;

  const onOwnerSubmit = async (values) => {
    setLoading(true);
    try {
      await ffinAddOwner({
        appealId: chosenBankAppealId,
        iin: (values?.iin || '').replace(/\D/g, ''),
        mobilePhone: (values?.mobilePhone || '').replace(/\D/g, ''),
      });
      alert.success('ÐÐ°Ð½Ð½ÑÐµ Ð²Ð»Ð°Ð´ÐµÐ»ÑÑÐ° Ð¾ÑÐ¿ÑÐ°Ð²Ð»ÐµÐ½Ñ Ð² Ð±Ð°Ð½Ðº. ÐÐ»Ð°Ð´ÐµÐ»ÑÑÑ Ð½Ð°Ð¿ÑÐ°Ð²Ð»ÐµÐ½Ð¾ Ð¡ÐÐ¡ Ð´Ð»Ñ ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ñ Ð½Ð° Ð¿ÑÐ¾Ð´Ð°Ð¶Ñ');
      update && update();
    } catch (e) {
      alert.error(extractErrorMessage(e?.response?.data) || 'Freedom Ð¾ÑÐºÐ»Ð¾Ð½Ð¸Ð» Ð´Ð°Ð½Ð½ÑÐµ Ð²Ð»Ð°Ð´ÐµÐ»ÑÑÐ°');
    } finally {
      setLoading(false);
    }
  };

  const onOwnerChangePhone = async (values) => {
    setLoading(true);
    try {
      await ffinUpdateOwnerPhone({
        appealId: chosenBankAppealId,
        mobilePhone: (values?.mobilePhone || '').replace(/\D/g, ''),
      });
      alert.success('ÐÐ¾Ð¼ÐµÑ Ð²Ð»Ð°Ð´ÐµÐ»ÑÑÐ° Ð¸Ð·Ð¼ÐµÐ½ÑÐ½. Ð¡ÐÐ¡ Ð´Ð»Ñ ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ñ Ð¾ÑÐ¿ÑÐ°Ð²Ð»ÐµÐ½Ð¾ Ð½Ð° Ð½Ð¾Ð²ÑÐ¹ Ð½Ð¾Ð¼ÐµÑ');
      update && update();
    } catch (e) {
      alert.error(extractErrorMessage(e?.response?.data) || 'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð¸Ð·Ð¼ÐµÐ½Ð¸ÑÑ Ð½Ð¾Ð¼ÐµÑ Ð²Ð»Ð°Ð´ÐµÐ»ÑÑÐ°');
    } finally {
      setLoading(false);
    }
  };

  const onOwnerRestart = async () => {
    setLoading(true);
    try {
      await ffinRestartOwner({ appealId: chosenBankAppealId });
      alert.success('ÐÑÐ¾Ð²ÐµÑÐºÐ° Ð²Ð»Ð°Ð´ÐµÐ»ÑÑÐ° Ð¿ÐµÑÐµÐ·Ð°Ð¿ÑÑÐµÐ½Ð°');
      update && update();
    } catch (e) {
      alert.error(extractErrorMessage(e?.response?.data) || 'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð¿ÐµÑÐµÐ·Ð°Ð¿ÑÑÑÐ¸ÑÑ Ð¿ÑÐ¾Ð²ÐµÑÐºÑ Ð²Ð»Ð°Ð´ÐµÐ»ÑÑÐ°');
    } finally {
      setLoading(false);
    }
  };

  const onRegistrationSubmit = async (values) => {
    if (!values?.status) {
      alert.error('ÐÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ Ð²ÑÐ±ÑÐ°ÑÑ ÑÑÐ°ÑÑÑ ÑÐ´ÐµÐ»ÐºÐ¸');
      return;
    }
    if (needsOwner && values?.status?.value === DEAL_STATUS_WAITING_FOR_FREEDOM) {
      alert.error('Ð¡Ð½Ð°ÑÐ°Ð»Ð° Ð¾ÑÐ¿ÑÐ°Ð²ÑÑÐµ Ð´Ð°Ð½Ð½ÑÐµ Ð²Ð»Ð°Ð´ÐµÐ»ÑÑÐ° â Ð±Ð°Ð½Ðº Ð½Ðµ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ´Ð¸Ñ Ð¿ÐµÑÐµÑÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ñ ÐºÐ¾Ð¼Ð¸ÑÑÐ¸Ð¾Ð½Ð½Ð¾Ð³Ð¾ Ð°Ð²ÑÐ¾ Ð±ÐµÐ· Ð½Ð¸Ñ');
      return;
    }
    try {
      await editDeal({
        id: deal?.id,
        statusId: values?.status?.value,
        ...generateAllowedDocumentsJson([
          DOCUMENT_TYPES_CERTIFICATE_OF_CIRCUMSTANCES,
          DOCUMENT_TYPES_GUARANTEE_LETTER,
          DOCUMENT_TYPES_INVOICE,
          DOCUMENT_TYPES_TECH_PASSPORT,
          DOCUMENT_TYPES_CONTRACT,
          DOCUMENT_TYPES_POLES,
        ]),
      });
      if (values?.status?.value === DEAL_STATUS_WAITING_FOR_FREEDOM) {
        await ffinReRegisterConfirm({ appealId: chosenBankAppealId });
        await setStep({ dealId: deal?.id, step: DEAL_STEPS.FREEDOM.WAITING_FOR_FINAL_ACTIONS });
      }
      update && update();
    } catch (e) {
      alert.error(extractErrorMessage(e?.response?.data) || 'ÐÑÐ¸Ð±ÐºÐ° Ð¿ÑÐ¸ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´ÐµÐ½Ð¸Ð¸ Ð¿ÐµÑÐµÑÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ð¸');
    }
  };

  const uploadClientDocuments = async (values) => {
    try {
      await upload({
        dealId: deal?.id,
        fileTypeId: DOCUMENT_TYPES_CERTIFICATE_OF_CIRCUMSTANCES,
        file: values['doc'],
      });
      await sendMarriedDoc({ appealId: chosenBankAppealId });
      await editDeal({
        id: deal?.id,
        statusId: DEAL_STATUS_WAITING_FOR_REGISTRATION_DOCUMENTS,
        ...generateAllowedDocumentsJson([
          DOCUMENT_TYPES_CERTIFICATE_OF_CIRCUMSTANCES,
          DOCUMENT_TYPES_GUARANTEE_LETTER,
          DOCUMENT_TYPES_INVOICE,
        ]),
      });
      await setStep({ dealId: deal?.id, step: DEAL_STEPS.FREEDOM.WAITING_FOR_PAYMENT });
      update();
    } catch (err) {
      alert.error('ÐÑÐ¾Ð¸Ð·Ð¾ÑÐ»Ð° Ð¾ÑÐ¸Ð±ÐºÐ° Ð¿ÑÐ¸ Ð¾ÑÐ¿ÑÐ°Ð²ÐºÐµ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ¾Ð² Ð² Ð±Ð°Ð½Ðº');
    }
  };

  const goBack = (statusId, step) => {
    setLoading(true);
    editDeal({
      id: deal?.id,
      statusId,
      step,
    })
      .then(() => {
        update && update();
      })
      .finally(() => setLoading(false));
  };

  if (uploading) {
    return <UploadProgressBar progress={progress} fileName={currentFileName} />;
  }

  if (loading) {
    return <LoaderInline />;
  }

  if (step === DEAL_STEPS.FREEDOM.SIGN_CONTRACT) {
    return <ContractSign deal={deal} documents={documents} cars={cars} dealStepAfterSign={stepAfterSign} setLoading={setLoading} update={update}/>;
  }

  if (step === DEAL_STEPS.FREEDOM.WAITING_FOR_CLIENT_ACTIONS_ON_FREEDOM_SITE) {
    return (
      <>
        <FormHeading>Ð¡ÑÐ°ÑÑÑ</FormHeading>
        <Button
          text={'ÐÐ¶Ð¸Ð´Ð°ÐµÐ¼ Ð·Ð°Ð²ÐµÑÑÐµÐ½Ð¸Ñ Ð´ÐµÐ¹ÑÑÐ²Ð¸Ð¹ ÐºÐ»Ð¸ÐµÐ½ÑÐ° Ð½Ð° ÑÐ°Ð¹ÑÐµ Freedom Bank'}
          style={{ color: 'rgb(73, 65, 54)', border: '1px solid rgb(73, 65, 54)' }}
        />
        <div style={{ marginTop: 10 }}>
          <Button
            text={'ÐÐ°Ð·Ð°Ð´'}
            onClick={() => goBack(DEAL_STATUS_DOCUMENTS_PROCESSING, 5)}
            style={{ color: '#BABABA', border: '1px solid #BABABA', width: '140px' }}
          />
        </div>
        {/* <Button
          onClick={() => {
            setStep({ dealId: deal?.id, step: DEAL_STEPS.FREEDOM.WAITING_FOR_CLIENT_DOCUMENTS }).then(() => {
              update();
            });
          }}
          fill
        >
          ÐÐ°Ð»ÐµÐµ
        </Button> */}
      </>
    );
  }
  if (step === DEAL_STEPS.FREEDOM.WAITING_FOR_CLIENT_DOCUMENTS) {
    return (
      <>
        <StepControlButtons
          dealId={deal?.id}
          nextStep={DEAL_STEPS.FREEDOM.WAITING_FOR_PAYMENT}
          update={update}
          setLoading={setLoading}
        />
        <FreedomClientDocuments documents={documents} onSubmit={uploadClientDocuments} loading={uploading} />
        <div style={{ marginTop: 10 }}>
          <Button
            text={'ÐÐ°Ð·Ð°Ð´'}
            onClick={() => goBack(deal?.status?.id, DEAL_STEPS.FREEDOM.WAITING_FOR_CLIENT_ACTIONS_ON_FREEDOM_SITE)}
            style={{ color: '#BABABA', border: '1px solid #BABABA', width: '140px' }}
          />
        </div>
      </>
    );
  }
  if (step === DEAL_STEPS.FREEDOM.WAITING_FOR_PAYMENT) {
    return (
      <>
        <StepControlButtons
          dealId={deal?.id}
          prevStep={stepBeforePayment}
          nextStep={DEAL_STEPS.FREEDOM.AUTO_REGISTRATION}
          update={update}
          setLoading={setLoading}
        />
        <FreedomPaymentStatus onSubmit={onPaymentSubmit} documents={documents} sendPaymentSms={sendPaymentSms}/>
        <div style={{ marginTop: 10 }}>
          <Button
            text={'ÐÐ°Ð·Ð°Ð´'}
            onClick={() => goBack(deal?.status?.id, stepBeforePayment)}
            style={{ color: '#BABABA', border: '1px solid #BABABA', width: '140px' }}
          />
        </div>
      </>
    );
  }
  if (step === DEAL_STEPS.FREEDOM.AUTO_REGISTRATION) {
    return (
      <>
        <StepControlButtons
          dealId={deal?.id}
          prevStep={DEAL_STEPS.FREEDOM.WAITING_FOR_PAYMENT}
          update={update}
          setLoading={setLoading}
        />
        {isConsignment && (
          <FreedomOwnerInfo
            onSubmit={onOwnerSubmit}
            onChangePhone={onOwnerChangePhone}
            onRestart={onOwnerRestart}
            loading={loading}
            sent={ownerSent}
            revisionReason={chosenBankAppeal?.errorMessage}
          />
        )}
        <FreedomCarRegistration onSubmit={onRegistrationSubmit} loading={uploading} />
        <div style={{ marginTop: 10 }}>
          <Button
            text={'ÐÐ°Ð·Ð°Ð´'}
            onClick={() => goBack(deal?.status?.id, DEAL_STEPS.FREEDOM.WAITING_FOR_PAYMENT)}
            style={{ color: '#BABABA', border: '1px solid #BABABA', width: '140px' }}
          />
        </div>
      </>
    );
  }

  if (step === DEAL_STEPS.FREEDOM.WAITING_FOR_FINAL_ACTIONS) {
    return (
      <>
        <FormHeading>Ð¡ÑÐ°ÑÑÑ</FormHeading>
        <Button
          text={'ÐÐ¶Ð¸Ð´Ð°ÐµÐ¼ Ð·Ð°Ð²ÐµÑÑÐµÐ½Ð¸Ñ Ð½Ð° ÑÑÐ¾ÑÐ¾Ð½Ðµ Freedom Bank'}
          style={{ color: 'rgb(73, 65, 54)', border: '1px solid rgb(73, 65, 54)' }}
        />
        <div style={{ marginTop: 10 }}>
          <Button
            text={'ÐÐ°Ð·Ð°Ð´'}
            onClick={() => goBack(deal?.status?.id, DEAL_STEPS.FREEDOM.AUTO_REGISTRATION)}
            style={{ color: '#BABABA', border: '1px solid #BABABA', width: '140px' }}
          />
        </div>
      </>
    );
  }
};

export default FreedomFlow;
